import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { SharedService } from "../../../../../app/shared/services/shared.service";
import { AlertController } from "@ionic/angular";
@Component({
  selector: "back-button",
  templateUrl: "back-button.component.html",
  styleUrls: ["./back-button.component.scss"],
})
export class BackButtonComponent {
  @Input() navigateTo: string[] = null;
  @Input() unsavedChanges: boolean = false;
  @Output() saveAllChanges: EventEmitter<void> = new EventEmitter<void>();

  @Input() scale: number = 1;

  constructor(private location: Location, private router: Router, private sharedService: SharedService, private alertController: AlertController) {}

  async navigateBack(): Promise<void> {
    this.sharedService.hapticsImpactLight();

    if (this.unsavedChanges) {
      const alert = await this.alertController.create({
        header: `You have unsaved changes.`,
        message: `Would you like to save your changes before closing?`,
        cssClass: 'custom-alert alert-button min-width-modal-centered',
        buttons: [
            {
                text: 'Save Changes',
                handler: () => {
                  this.saveAllChanges.emit();
                  this.navigate();
                },
                cssClass: 'alert-button'
            },
            {
                text: 'Exit Without Saving',
                handler: () => {
                  this.navigate();
                },
                cssClass: 'alert-button no'
            }
        ],
      });
      
      await alert.present();
    } else {
      this.navigate();
    }
  }

  navigate() {
    if (this.navigateTo) {
      this.router.navigate(this.navigateTo);
      return;
    }
    this.location.back();
  }
}
